/*
 * past-hero-state.js
 *
 * 1. Measures the announcement bar height and writes it to a
 *    --announcement-height CSS variable so the absolutely-positioned
 *    header sits just below it instead of over it.
 * 2. Adds/removes `body.past-hero` based on whether the user has
 *    scrolled past the first non-header section (the homepage hero).
 *    CSS uses this to keep the transparent header + white icons in
 *    place while still over the hero, and switch to opaque + dark
 *    once below. Toggles symmetrically so scrolling back up into the
 *    hero re-applies the transparent state.
 */
(function () {
  var isHomepage = document.body.classList.contains('template-index');

  function findHero() {
    var nodes = document.querySelectorAll(
      '#MainContent > .shopify-section, main > .shopify-section, .body-content-wrapper > .shopify-section'
    );
    for (var i = 0; i < nodes.length; i++) {
      var cls = nodes[i].className || '';
      if (cls.indexOf('header') === -1 && cls.indexOf('preload') === -1) return nodes[i];
    }
    return null;
  }

  function findAnnouncementBar() {
    return (
      document.querySelector('#shopify-section-announcement-bar .announcement-bar') ||
      document.querySelector('#shopify-section-announcement-bar') ||
      document.querySelector('.announcement-bar')
    );
  }

  var hero = null;
  var ticking = false;

  function updateAnnouncementHeight() {
    var bar = findAnnouncementBar();
    if (!bar) return;
    var rect = bar.getBoundingClientRect();
    if (rect.height > 0) {
      document.documentElement.style.setProperty('--announcement-height', rect.height + 'px');
    }
  }

  function updateHeaderPull() {
    // The desktop header (.section-header-navigation) is hidden on
    // mobile, where .section-header-mobile renders instead. Measure
    // whichever candidate is actually visible (height > 0) so
    // --header-pull is right on every viewport; previously only the
    // desktop selectors were tried, so mobile stayed on the 80px
    // CSS fallback and opened a gap above the page content.
    var candidates = [
      '.section-header-navigation .header-navigation-wrapper',
      '.section-header-navigation .header-nav-hamburger',
      '.section-header-navigation',
      '.section-header-mobile .header-mobile',
      '.section-header-mobile'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var header = document.querySelector(candidates[i]);
      if (!header) continue;
      var rect = header.getBoundingClientRect();
      if (rect.height > 0) {
        document.documentElement.style.setProperty('--header-pull', rect.height + 'px');
        return;
      }
    }
  }

  // Cached so per-scroll work is just an arithmetic + style write.
  var cachedAnnouncementHeight = 0;
  function refreshLayoutCache() {
    var bar = findAnnouncementBar();
    if (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0) {
        cachedAnnouncementHeight = rect.height;
        document.documentElement.style.setProperty('--announcement-height', rect.height + 'px');
      }
    }
    updateHeaderPull();
  }

  function updateHeaderTop() {
    var scrolled = window.scrollY || window.pageYOffset || 0;
    var topNow = Math.max(0, cachedAnnouncementHeight - scrolled);
    document.documentElement.style.setProperty('--header-top-now', topNow + 'px');
  }

  function update() {
    updateHeaderTop();

    // past-hero logic is homepage-only — other pages don't have a
    // hero section, they just need the announcement-follow header.
    if (!isHomepage) {
      ticking = false;
      return;
    }

    if (!hero) hero = findHero();
    if (!hero) {
      ticking = false;
      return;
    }
    var rect = hero.getBoundingClientRect();
    var heroHeight = rect.height;
    if (heroHeight < 200) {
      ticking = false;
      return;
    }
    var heroTop = rect.top + (window.scrollY || window.pageYOffset || 0);
    var heroBottom = heroTop + heroHeight;
    var scrolled = window.scrollY || window.pageYOffset || 0;
    document.body.classList.toggle('past-hero', scrolled >= heroBottom - 60);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function initLayout() {
    refreshLayoutCache();
    update();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    refreshLayoutCache();
    update();
  });
  window.addEventListener('load', initLayout);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLayout);
  } else {
    initLayout();
  }

  setTimeout(initLayout, 500);
  setTimeout(initLayout, 1500);
})();
